import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnButton from '@ui/components/VnButton';
import ModalPopup from '@ui/components/VnModal';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AddPurchaseInvoiceLineForm from './AddPurchaseInvoiceLineForm';
import PurchaseInvoiceLineTable from './PurchaseInvoiceLineTable';
import { getAllPurchaseInvoiceLineByIdAsync } from '@application/features/purchaseInvoiceLines/purchaseInvoiceLineThunk';
import { UpdatePurchaseInvoiceAsync } from '@application/features/purchaseInvoices/purchaseInvoiceThunk';
import PurchaseInvoiceLineViewTable from './PurchaseInvoiceLineViewTable';
import { handleRolePermission } from '@infrastructure/helpers';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { resetTimer, setModuleLock, unsetModuleLock } from '@application/features/workorders/workorderSlice';
import { VisserModule } from '@application/common/enums/visser-module';
import { updateModulePermissionsStatusAsync } from '@application/features/workorders/workorderThunk';
const PurchaseInvoiceLineTab = ({ formData, onFieldChange, isPurchaseInvoiceDisable, isPurchaseInvoiceLineTabBold }) => {
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const [isAddModalPopupOpen, setIsAddModalPopupOpen] = useState(false);
    const [purchaseInvoiceLineId, setPurchaseInvoiceLineId] = useState(0);
    const [purchaseInvoiceLineData, setPurchaseInvoiceLineData] = useState();
    const { SelectedCalculationForPurchaseInvoice } = useAppSelector((state) => state.order);
    const onAddPurchaseInvoiceLineLineClick = () => {
        setIsAddModalPopupOpen(true);
        setPurchaseInvoiceLineId(0);
    };
    function oncloseClicked() {
        if (id) {
            dispatch(getAllPurchaseInvoiceLineByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                if (isPurchaseInvoiceLineTabBold && res.length > 0) {
                    isPurchaseInvoiceLineTabBold(true);
                }
                else {
                    isPurchaseInvoiceLineTabBold && isPurchaseInvoiceLineTabBold(false);
                }
            });
        }
        setIsAddModalPopupOpen(false);
    }
    useEffect(() => {
        if (id) {
            dispatch(getAllPurchaseInvoiceLineByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setPurchaseInvoiceLineData(res);
                if (isPurchaseInvoiceLineTabBold && res.length > 0) {
                    isPurchaseInvoiceLineTabBold(true);
                }
                else {
                    isPurchaseInvoiceLineTabBold && isPurchaseInvoiceLineTabBold(false);
                }
            });
        }
    }, [dispatch, id]);
    const handlePurchaseInvoiceLineGridUpdate = () => {
        if (id) {
            dispatch(getAllPurchaseInvoiceLineByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setPurchaseInvoiceLineData(res);
                const total = res.reduce((acc, amount) => {
                    const itemTotal = (amount.quantity * amount.netPrice).toFixed(2);
                    return acc + parseFloat(itemTotal);
                }, 0);
                const inclusiveTotalAmount = total * 1.21;
                const updatedFormData = {
                    ...formData,
                    invoiceAmountExclVAT: total,
                    invoiceAmountInclVAT: inclusiveTotalAmount
                };
                dispatch(UpdatePurchaseInvoiceAsync(updatedFormData));
            });
        }
    };
    async function onPurchaseInvoiceLineGridRowClick(rowId) {
        var moduleLockStatus = await checkModulelock();
        if (moduleLockStatus == false) {
            setPurchaseInvoiceLineId(rowId);
            setIsAddModalPopupOpen(true);
        }
    }
    const checkModulelock = async () => {
        if (parseInt(id)) {
            dispatch(resetTimer());
            var moduleLockRequestData = {
                moduleId: VisserModule.Inkoopfacturen,
                recordId: parseInt(id)
            };
            try {
                const res = await dispatch(updateModulePermissionsStatusAsync(moduleLockRequestData))
                    .unwrap()
                    .then();
                if (res.isModuleAlreadyLocked) {
                    // setIsPersistantInfoCustomToasterOpen(true);
                    dispatch(setModuleLock());
                    return true;
                }
                else {
                    dispatch(unsetModuleLock());
                    // setIsPersistantInfoCustomToasterOpen(false);
                    return false;
                }
            }
            catch (error) {
                dispatch(unsetModuleLock());
                return false;
            }
        }
        return false;
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'vn-Material-Add-buttons', children: id && (_jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3', icon: addOutline, onClick: async () => {
                        var moduleLockStatus = await checkModulelock();
                        if (moduleLockStatus == false) {
                            onAddPurchaseInvoiceLineLineClick();
                        }
                    }, style: { marginRight: '5px' }, isDisabled: handleRolePermission(Permission.INKOOPFACTUREN, PermissionType.Update) && id && !isPurchaseInvoiceDisable
                        ? false
                        : true, children: "Regel toevoegen" })) }), id ? (_jsx(PurchaseInvoiceLineTable, { handleGridRowCLick: onPurchaseInvoiceLineGridRowClick, purchaseInvoiceLineData: purchaseInvoiceLineData, formData: formData })) : (_jsx(PurchaseInvoiceLineViewTable, { formData: formData, handleFieldChange: onFieldChange, SelectedWorkorderCalculationsToOrderItemIdsList: SelectedCalculationForPurchaseInvoice, isPurchaseInvoiceLineTabBold: isPurchaseInvoiceLineTabBold })), _jsx(ModalPopup, { title: 'Toevoegen regels', content: _jsx(AddPurchaseInvoiceLineForm, { onClose: () => oncloseClicked(), purchaseInvoiceLineId: purchaseInvoiceLineId, onPurchaseInvoiceLineGridUpdate: handlePurchaseInvoiceLineGridUpdate, isPurchaseInvoiceDisable: isPurchaseInvoiceDisable }), onOpen: isAddModalPopupOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default PurchaseInvoiceLineTab;
